// Generated by ReScript, PLEASE EDIT WITH CARE

import * as DomEl$GameDataCore from "../DomEl.res.mjs";

function readValue(element) {
  var fromData = DomEl$GameDataCore.data(element, "value");
  if (fromData !== "") {
    return fromData;
  }
  var value = element.getAttribute("data-value");
  if (value == null) {
    return "";
  } else {
    return value;
  }
}

function mounted() {
  var self = this ;
  var element = self.el;
  var offClick = DomEl$GameDataCore.on(element, "click", (function ($$event) {
          $$event.stopPropagation();
        }));
  var offChange = DomEl$GameDataCore.on(element, "change", (function (_event) {
          var value = readValue(element);
          if (value !== "") {
            self.pushEvent("select-table-row", {
                  value: value
                });
            return ;
          }
          
        }));
  self._off = (function () {
      offClick();
      offChange();
    });
}

function destroyed() {
  var self = this ;
  var unsubscribe = self._off;
  unsubscribe();
}

var selectTableRow = {
  mounted: mounted,
  destroyed: destroyed
};

export {
  readValue ,
  mounted ,
  destroyed ,
  selectTableRow ,
}
/* mounted Not a pure module */
